import { AUTH_ENDPOINTS } from "@/shared/config/auth"
import { authClient } from "./auth-client"

/** Response of the refresh endpoint; the interceptor only needs the new access token. */
interface RefreshResponse {
	accessToken: string
	expiresIn: string
}

const REFRESH_LOCK = "kmk-auth-refresh"

let inFlight: Promise<RefreshResponse> | null = null

const requestRefresh = async (): Promise<RefreshResponse> => {
	const { data } = await authClient.post<RefreshResponse>(AUTH_ENDPOINTS.REFRESH)
	return data
}

/**
 * Обновляет access-токен по refresh-cookie. api меняет refresh-токен при каждом обновлении
 * и второй запрос со старым считает кражей, закрывая сессию. Поэтому одновременные вызовы
 * внутри вкладки делят один запрос, а вкладки встают в очередь через Web Locks: следующая
 * отправит уже новую cookie.
 */
export const refreshToken = (): Promise<RefreshResponse> => {
	if (!inFlight) {
		const run: Promise<RefreshResponse> =
			typeof navigator !== "undefined" && navigator.locks
				? (navigator.locks.request(
						REFRESH_LOCK,
						requestRefresh,
					) as unknown as Promise<RefreshResponse>)
				: requestRefresh()
		inFlight = run.finally(() => {
			inFlight = null
		})
	}
	return inFlight
}
